<template>
  <div id="view">
    <historyTag :historyArr="historyArr"></historyTag>

    <div id="mainBox">
      <div class="bannerList">
        <div class="topBox flex">
          <ul class="flex">
            <li class="flex">
              <div style="width: 220px">
                <el-input v-model="searchKeyword" placeholder="搜索关键词" clearable></el-input>
              </div>
            </li>
            <li class="flex" style="margin-left: 12px">
              <el-select v-model="statusFilter" placeholder="状态" clearable style="width: 140px">
                <el-option label="待处理" :value="0"></el-option>
                <el-option label="有效" :value="1"></el-option>
                <el-option label="无效" :value="2"></el-option>
              </el-select>
            </li>
            <li class="flex" style="margin-left: 12px">
              <el-button type="success" size="small" @click="searchFn">搜索</el-button>
            </li>
          </ul>
        </div>

        <el-table border :data="tableData" style="width: 100%; margin-top: 10px">
          <el-table-column prop="id" align="center" label="ID" width="70"></el-table-column>
          <el-table-column prop="keyword" align="center" label="搜索关键词" min-width="160"></el-table-column>
          <el-table-column prop="searchCount" align="center" label="搜索次数" width="100"></el-table-column>
          <el-table-column align="center" label="状态" width="100">
            <template slot-scope="scope">
              <span>{{ statusText(scope.row.status) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="remark" align="center" label="备注" min-width="120" show-overflow-tooltip></el-table-column>
          <el-table-column prop="createTime" align="center" label="创建时间" width="170"></el-table-column>
          <el-table-column prop="updateTime" align="center" label="更新时间" width="170"></el-table-column>
          <el-table-column align="center" label="操作" width="120" fixed="right">
            <template slot-scope="scope">
              <el-button type="primary" size="small" @click="openEdit(scope.row)">处理</el-button>
            </template>
          </el-table-column>
        </el-table>

        <div class="page_box">
          <el-pagination
            @current-change="changePage"
            :current-page.sync="currentPage"
            :page-size="pageSize"
            layout="total, prev, pager, next, jumper"
            :total="tableTotal"
          ></el-pagination>
        </div>
      </div>

      <el-dialog title="处理记录" :visible.sync="dialogVisible" width="480px" @close="resetDialog">
        <el-form label-width="88px">
          <el-form-item label="关键词">
            <span>{{ editRow.keyword }}</span>
          </el-form-item>
          <el-form-item label="状态">
            <el-radio-group v-model="editStatus">
              <el-radio :label="0">待处理</el-radio>
              <el-radio :label="1">有效</el-radio>
              <el-radio :label="2">无效</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="备注">
            <el-input type="textarea" v-model="editRemark" :rows="3" placeholder="可选"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" :loading="submitLoading" @click="submitEdit">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { returnTime } from "@/util/utils";

export default {
  data() {
    return {
      historyArr: ["批号查询管理", "型号搜索无结果"],
      searchKeyword: "",
      statusFilter: null,
      currentPage: 1,
      pageSize: 10,
      tableTotal: 0,
      tableData: [],
      dialogVisible: false,
      submitLoading: false,
      editRow: {},
      editStatus: 0,
      editRemark: "",
    };
  },
  mounted() {
    this.selListFn(1);
  },
  methods: {
    statusText(s) {
      if (s === 0) return "待处理";
      if (s === 1) return "有效";
      if (s === 2) return "无效";
      return "-";
    },
    searchFn() {
      this.currentPage = 1;
      this.selListFn(1);
    },
    changePage(page) {
      this.selListFn(page);
    },
    selListFn(page) {
      if (page) this.currentPage = page;
      var obj = {
        page: this.currentPage || 1,
        size: this.pageSize,
      };
      if (this.searchKeyword) {
        obj.keyword = this.searchKeyword.trim();
      }
      if (this.statusFilter !== null && this.statusFilter !== "") {
        obj.status = this.statusFilter;
      }
      this.$https(this.$api.api.selTypeSearchMiss, obj, "POST").then((res) => {
        if (res.data && res.data.code == 200) {
          var data = res.data.data || [];
          data.forEach((v) => {
            if (v.createTime) {
              v.createTime = returnTime(new Date(v.createTime), "-", "s");
            }
            if (v.updateTime) {
              v.updateTime = returnTime(new Date(v.updateTime), "-", "s");
            }
          });
          this.tableData = data;
          this.tableTotal = res.data.size || 0;
        } else {
          this.tableData = [];
          this.tableTotal = 0;
          this.$message.error((res.data && res.data.msg) || "查询失败");
        }
      });
    },
    openEdit(row) {
      this.editRow = { ...row };
      this.editStatus = row.status != null ? row.status : 0;
      this.editRemark = row.remark || "";
      this.dialogVisible = true;
    },
    resetDialog() {
      this.editRow = {};
      this.editRemark = "";
      this.submitLoading = false;
    },
    submitEdit() {
      if (!this.editRow.id) return;
      this.submitLoading = true;
      this.$https(
        this.$api.api.upTypeSearchMissStatus,
        {
          id: this.editRow.id,
          status: this.editStatus,
          remark: this.editRemark,
        },
        "POST"
      )
        .then((res) => {
          this.submitLoading = false;
          if (res.data && res.data.code == 200) {
            this.$message.success(res.data.msg || "更新成功");
            this.dialogVisible = false;
            this.selListFn(this.currentPage);
          } else {
            this.$message.error((res.data && res.data.msg) || "更新失败");
          }
        })
        .catch(() => {
          this.submitLoading = false;
        });
    },
  },
};
</script>

<style scoped lang="less">
#mainBox {
  width: 100%;
  padding: 15px;
  box-sizing: border-box;
}
.topBox {
  width: 100%;
  margin-bottom: 10px;
  text-align: right;
  justify-content: space-between;
}
.bannerList {
  width: 100%;
}
.page_box {
  margin-top: 16px;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/pages/batchQuery/typeSearchMiss.vue